import React, { useState, useEffect } from 'react'
//import i18n from '../../i18n'
import TestimonialsBanner from './testimonials.page.banner'
import Suscribe from '../suscribe'
import GetInTouch from '../getIntouch'
import Selector from './testimonials.page.selector'
import TestimonialsSwiperCarousel from './testimonials.swiper.carousel'
import testimonialsData from './testimonials.data'

export default function TestimonialsPage(props) {
    const { language } = props
    const [testimonial, setTestimonial] = useState('seller')
    const { testimonialsTextSeller, testimonialsMediaSeller, testimonialsTextBuyer, testimonialsMediaBuyer } = testimonialsData

    return (
        <section className="testimonials-section">
            <div className={'testimonials-section-content white py-3'}>
                <TestimonialsBanner />

                <div className={'container'}>
                    <Selector
                        testimonial={testimonial}
                        setTestimonial={setTestimonial}
                    />

                    <TestimonialsSwiperCarousel customClassName={(testimonial === 'buyer' && !testimonialsMediaBuyer.length) || (testimonial === 'seller' && !testimonialsMediaSeller.length) ? 'py-0' : ''} data={testimonial === 'seller' ? testimonialsMediaSeller : testimonialsMediaBuyer} effect={'coverflow'} slidesPerView={'auto'} autoplay={false} initialSlide={testimonial === 'seller' ? Math.floor(testimonialsMediaSeller.length / 2) : Math.floor(testimonialsMediaBuyer.length / 2)} />
                    <TestimonialsSwiperCarousel data={testimonial === 'seller' ? testimonialsTextSeller : testimonialsTextBuyer} effect={'coverflow'} slidesPerView={'auto'} autoplay={true} initialSlide={testimonial === 'seller' ? Math.floor(testimonialsTextSeller.length / 2) : Math.floor(testimonialsTextBuyer.length / 2)} />
                </div>
            </div>

            <Suscribe language={language} />
            <GetInTouch language={language} />
        </section>
    )
}
